$( document ).ready(function() {
    $('.mmenuclick').click(function(e){
      e.preventDefault();
      if(window.innerWidth <481)
      {
        if($(this).closest('ul').hasClass('.show'))
        {
          $(this).closest('ul').removeClass('.show').find('li a').not('.mmenuclick').css('display','none');
        }
        else{
          $(this).closest('ul').addClass('.show').find('li a').css('display','block');
        }
      }
    })
});

var cammiejs = {
  validateemail:function(mail) 
  {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
     if (mail.match(mailformat))
      {
        return true;
      }
      return false;
  },
  joincommunity:function() {   
    var vResult = cammiejs.validateemail($('.newslttr').val());
    var vtboxobj = $('.newslttr').closest('.jcc_tbox');
    vtboxobj.removeClass('error');
    $('#ContactFooter-success').remove();
    if (!vResult) {
      vtboxobj.addClass('error').find('.error_txt').html('Please enter a valid email address');
    }
    return vResult;
  }
};